import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-publish",
  "use": "icon-publish-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-publish\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 0 384 704 0 576 1024 0ZM1024 0 1024 896 483.414063 732.851565 1024 0ZM384 740.488282 364.578125 734.300781 512 1024 606.945313 805.5 476.078125 768 496.279297 960 384 740.488282Z\" p-id=\"9183\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol